import React, { useState, useMemo } from 'react';
import CalcShell from '../CalcShell';

export default function CountdownCalc() {
  const [target, setTarget] = useState(() => {
    const d = new Date(); d.setFullYear(d.getFullYear() + 1);
    return d.toISOString().slice(0, 16);
  });
  const [now, setNow] = useState(new Date());
  React.useEffect(() => { const t = setInterval(() => setNow(new Date()), 1000); return () => clearInterval(t); }, []);
  const diff = useMemo(() => {
    const t = new Date(target).getTime();
    let ms = t - now.getTime();
    if (ms < 0) ms = 0;
    const days = Math.floor(ms / 86400000); ms -= days*86400000;
    const hours = Math.floor(ms / 3600000); ms -= hours*3600000;
    const mins = Math.floor(ms / 60000); ms -= mins*60000;
    const secs = Math.floor(ms / 1000);
    return { days, hours, mins, secs };
  }, [target, now]);
  const Box = ({ v, l }) => (
    <div className="bg-blue-600 text-white rounded-2xl px-6 py-6 text-center min-w-[100px]">
      <div className="text-5xl font-extrabold">{String(v).padStart(2, '0')}</div>
      <div className="text-xs uppercase tracking-wider mt-1">{l}</div>
    </div>
  );
  return (
    <CalcShell look="cnet" title="Countdown Timer" subtitle="Countdown to any future date and time.">
      <div className="field max-w-md"><label>Target Date &amp; Time</label><input type="datetime-local" value={target} onChange={e => setTarget(e.target.value)} /></div>
      <div className="flex flex-wrap gap-3 mt-6 justify-center">
        <Box v={diff.days} l="Days" /><Box v={diff.hours} l="Hours" /><Box v={diff.mins} l="Minutes" /><Box v={diff.secs} l="Seconds" />
      </div>
    </CalcShell>
  );
}
